import axios from "../http_v2";

export default {
  list(params) {
    return axios.get("cmsservice/cms_solution/page", params);
  },
  listall(params) {
    return axios.get("cmsservice/cms_solution/page/share", params);
  },
  info(id) {
    return axios.get("cmsservice/cms_solution/info/" + id, {});
  },
  add(params) {
    return axios.post("cmsservice/cms_solution/add", params);
  },
  update(params) {
    return axios.post("cmsservice/cms_solution/update", params);
  },
  //修改状态，上架和下架
  status(params) {
    return axios.get("cmsservice/cms_solution/status", params);
  },
  //置顶
  top(params) {
    return axios.get("cmsservice/cms_solution/top", params);
  },
  delete(params) {
    return axios.post("cmsservice/cms_solution/delete", params);
  },
  type: {
    tree(params) {
      return axios.get("cmsservice/solutionSort/tree", params);
    },
    add(params) {
      return axios.post("cmsservice/solutionSort/add", params);
    },
    update(params) {
      return axios.put("cmsservice/solutionSort/update", params);
    },
    del(id) {
      return axios.delete("cmsservice/solutionSort/del/" + id, {});
    }
  }
};
